import {Component, HostListener, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FooterService} from '../../services/footer.service';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css']
})
export class PortfolioComponent implements OnInit {

  footerHeight: number;

  constructor(private router: Router, private footerService: FooterService) { }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    setTimeout(() => {
      this.footerHeight = this.footerService.getFooterHeight();
    }, 500);
  }

  ngOnInit(): void {
    this.footerHeight = this.footerService.getFooterHeight();
    console.log('cc ' + this.footerHeight);
  }

}
